import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCreditsType',
  standalone: false
})
export class FilterCreditsTypePipe implements PipeTransform {
  transform(credits: any[], isNation: boolean): any {
    return credits.filter(credit => credit.isNation === isNation);
  }
}
